export const generateId = (): string => Math.random().toString(36);
